<template>
		<MainLayout>
			<div class="container">
				<div class="box">
					<b-button v-if="$hasPermission('supplier.add')" class="float-right" @click="newModel" >Nuevo Proveedor</b-button>
					<h2>Proveedores</h2>
					<hr>
					<b-form @submit="(evt) => { evt.preventDefault(); this.$root.$emit('bv::refresh::table', 'suppliers-index-list') } ">
						<div class="row">
								<b-form-group class="col-2" label="Buscar">
									<b-form-input v-model="filters.search" type="text" />
								</b-form-group>
								<b-form-group class="col-2" label=".">
									<b-button type="submit" variant="primary">Buscar</b-button>
								</b-form-group>
						</div>
					</b-form>
					<AjaxTable
						permission-show="supplier.show"
						id="suppliers-index-list"
						:filters="filters"
						:columns="modelColumns"
						resource="suppliers"
					>
						<template v-slot:cell(actions)="row">
							<div class="text-center">
								<b-button  @click="(event) => editModel(row.item.id)" type="button" size="sm" class="mr-1" variant="info">
									<md-icon icon="edit" />
								</b-button>
								<b-button v-if="$hasPermission('supplier.delete')" @click="(event) => modelDelete(row.item,row.index,event)" type="button" size="sm" class="mr-1" variant="danger">
									<md-icon icon="delete" />
								</b-button>
							</div>
						</template>
					</AjaxTable>
				</div>
				<hr>
			</div>
			<Single ref="single" :unableEdit.sync="unableEdit" :success-callback="successCallback" />
		</MainLayout>
</template>

<script>
import MainLayout from '../layout/MainLayout.vue'
import AjaxTable from '../../helpers/AjaxTable.vue'
import Single from './Single.vue'
import api from '../../../api.js'

export default {
		components: { MainLayout, Single, AjaxTable },
		data(){
				return {
					unableEdit: false,
					modalInfo : {
						modelId:-1,
						title:"Destino",
					},
					filters : {
						search:'',
					},
					modelColumns : [
						{key:'id',label:'ID'},
						{key:'code',label:'Codigo'},
						{key:'name',label:'Nombre'},
						{key:'emailNotifications',label:'Email Notificaciones'},
						{key:'zonedAreasTitles',label:'Áreas de operación'},
						//{key:'supplierZonedAreasTitle',label:'Áreas de operación proveedor'},
						{key:'status',label:'Estado'},
						{key:'actions',label:'Acciones'},
					],
				}
		},
		methods:{
			successCallback(){
				this.$root.$emit('bv::refresh::table', 'suppliers-index-list')
			},
			editModel(id){
				this.unableEdit = !this.$hasPermission('supplier.edit')
				this.$refs['single'].loadModel(id)
			},
			newModel(){
				this.unableEdit = false
				this.$refs['single'].loadModel(-1)
			},
			modelDelete(item){
				this.$root.showWarning({
					okAction: (event, setLoading, close) => {
						setLoading(true)
						api(this).delete(`/suppliers/${item.id}`).then((response) => {

							if(response.data.error) {
								this.$root.showAlert(response.data.message, { variant: 'warning' })
								close()
								return false
							}

							this.$root.showAlert('Registro Eliminado!',{variant:'warning'})
							this.$root.$emit('bv::refresh::table', 'suppliers-index-list')
							this.$root.auxVars.loadResourcesOpts({
								vm: this,
								resourceNames: ["suppliersOpts"],
								forceRefresh: true
							});
							close()

						}).catch( err => {
							this.$root.handleRequestError(err)
							close()
						});
					}
				})
			}
		},
		mounted(){
		}
}
</script>

<style>

</style>
